import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Notify from "../utils/useNotify";

export default function AccountDetails() {
  const { t } = useTranslation();
  const localhost = process.env.REACT_APP_LOCALHOST;
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({
    username: '',
    password: ''
  });

  const [ref, setRef] = useState(false);
  const [usernameActive, setUsernameActive] = useState(false);
  const [emailActive, setEmailActive] = useState(false);
  const [pswActive, setPswActive] = useState(false);

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    setLoading(true);
    const fetchUserData = async () => {
      try {
        const user = await axios.get(`${localhost}user`, { headers: { Authorization: `Bearer ${token}` } });
        const data = user.data;
        if (data) {
          setUsername(data.username);
          setEmail(data.email);
        }
      } catch (err) {
        // 
      }finally {
        setLoading(false);
      }
    };
    fetchUserData();
  }, [ref]);

  const updateUsername = (e) => {
    e.preventDefault();
    axios.put(localhost + "update-username", { username }, { headers: { 'Authorization': `Bearer ${token}` } })
      .then((res) => {
        setError({ username: '' });
        setRef(!ref);
        setUsernameActive(false);
        Notify('success', t("s-up-username"));
        localStorage.setItem("username", username);
        setTimeout(() => { window.location.reload() }, 1000);
      }).catch((err) => { console.error(err);; Notify('error', t("e-up-username")) });
  };

  const updateEmail = (e) => {
    e.preventDefault();
    axios.put(localhost + "update-email", { email }, { headers: { 'Authorization': `Bearer ${token}` } })
      .then((res) => {
        setRef(!ref);
        setEmailActive(false);
        Notify('success', t("s-up-email"))
      }).catch((err) => Notify('error', t("e-up-email")));
  };

  const updatePassword = (e) => {
    e.preventDefault();
    if (newPassword === confirmPassword) {
      setError({ password: '' });
      axios.put(localhost + "update-password", { 'current_password': currentPassword, 'new_password': newPassword, "new_password_confirmation": confirmPassword }, { headers: { 'Authorization': `Bearer ${token}` } })
        .then((res) => {
          setPswActive(false);
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");
          Notify('success', t("s-up-psw"));
        }).catch((err) => {
          if (err.status) {
            const error = JSON.parse(err.request.response);
            setError({ passwordll: error.message });
          } else {
            Notify('error', t("e-up-psw"));
          }
        });
    } else {
      setError({ password: 'error-not-match' });
    }
  };

  if (loading) {
    return (
      <div className="min-h-[55vh] flex items-center justify-center">
        <div className="loading-spinner" />
      </div>
    )
  }

  return (
    <div className='col-span-8 pb-10 overflow-hidden rounded-lg p-6 shadow-sm border bg-white'>
      <h1 className="pt-2 text-xl text-black font-semibold">{t("account-details")}</h1>
      <p className="text-slate-600 text-sm">{(t("leave-blank"))}</p>
      <hr className="mt-4 mb-6" />
      <p className="pt-2 text-base text-black font-semibold">{t("username")}</p>
      {
        usernameActive === false ?
          (<div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
            <p className="text-gray-600 text-sm">{t("edit-username")} <strong className='underline'>{username}</strong></p>
            <button type="button" onClick={() => setUsernameActive(true)} className="inline-flex text-sm font-medium text-orange-500 hover:underline decoration-2">{t("edit")}</button>
          </div>)
          : (<form onSubmit={updateUsername} className="mb-5">
            <div className="flex flex-wrap gap-1">
              <input value={username} onChange={(e) => setUsername(e.target.value)} type="text" className={`${error.username ? "error-border focus:ring-red-700 focus:border-red-700" : "focus:ring-orange-500 focus:border-orange-500"} max-w-sm bg-gray-50 border text-black text-sm rounded-lg block w-full p-2.5`} placeholder="john.doe" />

              <button type="submit" className="text-white mt-4 sm:mt-0 bg-black hover:bg-black/80 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none">{t("save")}</button>
              <button type="button" onClick={() => setUsernameActive(false)} className="text-black mt-4 sm:mt-0 bg-gray-50 hover:bg-gray-200 border focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none">{t("cancel")}</button>
            </div>
            {error.username && <p className="text-sm text-red-700">{t(error.username)}</p>}
          </form>)
      }
      <hr className="mt-4 mb-4" />
      <p className="pt-2 text-base text-black font-semibold">{t("edit-email")}</p>
      {
        emailActive === false ?
          (<div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
            <p className="text-gray-600 text-sm">{t("edit-email-1")} <strong className='underline'>{email}</strong></p>
            <button type="button" onClick={() => setEmailActive(true)} className="inline-flex text-sm font-medium text-orange-500 hover:underline decoration-2">{t("edit")}</button>
          </div>)
          : (<form onSubmit={updateEmail} className="flex flex-wrap gap-1 mb-5">
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="text" className="max-w-sm bg-gray-50 border text-black text-sm rounded-lg focus:ring-orange-500 focus:border-orange-500 block w-full p-2.5" placeholder="john.doe@company.com" />

            <button type="submit" className="text-white mt-4 sm:mt-0 bg-black hover:bg-black/80 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none">{t("save")}</button>
            <button type="button" onClick={() => setEmailActive(false)} className="text-black mt-4 sm:mt-0 bg-gray-50 hover:bg-gray-200 border focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none">{t("cancel")}</button>
          </form>)
      }


      <hr className="mt-4 mb-4" />
      <p className="pt-2 text-base text-black font-semibold">{t("edit-password")}</p>
      {
        pswActive === false ?
          (<div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
            <p className="text-gray-600 text-sm">{t("edit-password-1")} <strong className='underline'>{t("edit-password-2")}</strong></p>
            <button type="button" onClick={() => setPswActive(true)} className="inline-flex text-sm font-medium text-orange-500 hover:underline decoration-2">{t("edit")}</button>
          </div>)
          : (<form onSubmit={updatePassword} className="max-w-sm">
            <div className="mb-5">
              <label className="block mb-2 text-sm font-medium text-black">{t("current-password")}</label>
              <input value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} type="password" className={`${error.passwordll ? "error-border focus:ring-red-700 focus:border-red-700" : "focus:ring-orange-500 focus:border-orange-500"} bg-gray-50 border text-black text-sm rounded-lg block w-full p-2.5`} placeholder={t("current-password") + "..."} />
              {error.passwordll && <p className="text-sm text-red-700">{t(error.passwordll)}</p>}
            </div>
            <div className="mb-5">
              <label className="block mb-2 text-sm font-medium text-black">{t("new-password")}</label>
              <input value={newPassword} onChange={(e) => setNewPassword(e.target.value)} type="password" className={`${error.password ? "error-border focus:ring-red-700 focus:border-red-700" : "focus:ring-orange-500 focus:border-orange-500"} bg-gray-50 border text-black text-sm rounded-lg block w-full p-2.5`} placeholder={t("new-password") + "..."} />
            </div>
            <div className="mb-5">
              <label className="block mb-2 text-sm font-medium text-black">{t("conf-new-password")}</label>
              <input value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} type="password" className={`${error.password ? "error-border focus:ring-red-700 focus:border-red-700" : "focus:ring-orange-500 focus:border-orange-500"} bg-gray-50 border text-black text-sm rounded-lg block w-full p-2.5`} placeholder={t("conf-new-password") + "..."} />
              {error.password && <p className="text-sm text-red-700">{t(error.password)}</p>}
            </div>

            <div className='flex flex-wrap justify-end gap-1'>
              <button type="submit" className="text-white mt-4 sm:mt-0 bg-black hover:bg-black/80 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none">{t("save")}</button>
              <button type="button" onClick={() => setPswActive(false)} className="text-black mt-4 sm:mt-0 bg-gray-50 hover:bg-gray-200 border focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none">{t("cancel")}</button>
            </div>
          </form>)
      }

    </div>
  )
}